import $http from '@/libs/axios'

export default class AdminInvoicesApi {
  static async changeStatus(id: number, data: any) {
    return (await $http.post(`admin/invoices/${id}`, data)).data
  }

  static async delete(id: number) {
    return (await $http.delete(`admin/invoices/${id}`)).data
  }

  static async total(query: string) {
    return (await $http.get(`admin/invoices/by-managers?${query}`)).data
  }

  static async process(data: any) {
    return (await $http.post('admin/invoices/process', data)).data
  }
}
